import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import { useEffect } from "react";

import ForgotPassword from "./component/ForgotPassword";
import ProtectedRoute from "./middleware/ProtectedRoute";
import Login from "./component/Login";

import SuperadminDashboard from "./component/Superadmin/SuperadminDashboard";
import AllOrgs from "./component/Superadmin/AllOrgs";
import CreateOrg from "./component/Superadmin/CreateOrg";
import EditOrg from "./component/Superadmin/EditOrg";
import EditAdmin from "./component/Superadmin/EditAdmin";

// Material Tracker admin screens
import AdminDashboard from "./component/Admin/AdminDashboard";
import OrgDetails from "./component/Admin/OrgDetails";
import AllOrgsUsers from "./component/Admin/AllOrgUsers";
import CreateUser from "./component/Admin/CreateUser";
import UploadPartMaster from "./component/Admin/UploadPartMaster";

import UserDashboard from "./component/Users/UserDashboard";
import Dashboard from "./component/Users/Dashboard";
import Shortages from "./component/Users/Shortages";
import Materials from "./component/Users/Materials";
import Requisitions from "./component/Users/Requisitions";
import PurchaseOrders from "./component/Users/PurchaseOrders";
import UploadReports from "./component/Users/UploadReports";
import MaterialDetail from "./component/Users/MaterialDetail";
import UploadBOM from "./component/Users/UploadBOM";
import {
  ALL_USER_ROLE_VALUES,
  UPLOADS,
  getUploadRoles,
} from "./utils/moduleAccess";

const uploadRoutes = [
  { upload: UPLOADS.BOM, element: <UploadBOM /> },
  { upload: UPLOADS.OPEN_PR, element: <UploadReports reportType="openPR" /> },
  { upload: UPLOADS.OPEN_PO, element: <UploadReports reportType="openPO" /> },
  { upload: UPLOADS.DELIVERY, element: <UploadReports reportType="delivery" /> },
];

function App() {
  useEffect(() => {
    const wheelHandler = (e) => {
      if (document.activeElement.matches("input[type=number]")) {
        e.preventDefault();
      }
    };

    const keyHandler = (e) => {
      if (
        document.activeElement.matches("input[type=number]") &&
        (e.key === "ArrowUp" || e.key === "ArrowDown")
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener("wheel", wheelHandler, {
      passive: false,
    });
    window.addEventListener("keydown", keyHandler);

    return () => {
      window.removeEventListener("wheel", wheelHandler);
      window.removeEventListener("keydown", keyHandler);
    };
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/user-onboarding" element={<ForgotPassword />} />

        {/* SUPERADMIN */}
        <Route element={<ProtectedRoute allowedRoles={["SUPERADMIN"]} />}>
          <Route path="/superadmin-dashboard" element={<SuperadminDashboard />}>
            <Route index element={<AllOrgs />} />
            <Route path="create-org" element={<CreateOrg />} />
            <Route path=":orgId" element={<EditOrg />} />
            <Route path=":orgId/admin" element={<EditAdmin />} />
          </Route>
        </Route>

        {/* ADMIN */}
        <Route element={<ProtectedRoute allowedRoles={["ADMIN"]} />}>
          <Route path="/admin" element={<AdminDashboard />}>
            <Route index element={<AllOrgsUsers />} />
            <Route path="org-details" element={<OrgDetails />} />
            <Route path="create-user" element={<CreateUser />} />
            <Route path=":orgUserId" element={<CreateUser />} />
            <Route path="part-master" element={<UploadPartMaster />} />
          </Route>
        </Route>

        {/* Material Tracker users */}
        <Route
          element={
            <ProtectedRoute allowedRoles={ALL_USER_ROLE_VALUES} />
          }
        >
          <Route path="/" element={<UserDashboard />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="shortages" element={<Shortages />} />
            <Route path="materials" element={<Materials />} />
            <Route path="requisitions" element={<Requisitions />} />
            <Route path="purchase-orders" element={<PurchaseOrders />} />
            <Route path="shortages/:key" element={<MaterialDetail />} />

            {/* Upload pages open only for the roles that upload that report */}
            {uploadRoutes.map(({ upload, element }) => (
              <Route
                key={upload.to}
                element={<ProtectedRoute allowedRoles={getUploadRoles(upload)} />}
              >
                <Route path={upload.to} element={element} />
              </Route>
            ))}
          </Route>
        </Route>

        {/* Unknown paths */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
